import axios from "axios";

function errorHandler(error, reject) {
  if (error.response && error.response.data) {
    const err = error.response.data;
    if (err.name == "JsonWebTokenError" || err.message == "jwt malformed") {
      const redirectPath = localStorage.getItem("redirectPath");
      window.localStorage.clear();
      if (redirectPath) localStorage.setItem("redirectPath", redirectPath);
      window.location.reload();
    } else if (err.name == "TokenExpiredError" || err.message == "jwt expired") {
      const redirectPath = localStorage.getItem("redirectPath");
      window.localStorage.clear();
      if (redirectPath) localStorage.setItem("redirectPath", redirectPath);
      window.location.reload();
    }
    reject(error.response.data);
  } else {
    reject(error);
  }
}

export default {
  apps() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/auth/usermodules/");
        resolve(data);
      } catch (error) {
        console.log(error);
        errorHandler(error, reject);
      }
    });
  },
  // listtodo(obj) {
  //     return new Promise(async (resolve, reject) => {
  //         try {
  //             const keys = ['page', 'limit', 'sortBy', 'sortDir'];
  //             let str = '';
  //             for (const key in obj) {
  //                 if (keys.indexOf(key) >= 0 && obj[key]) {
  //                     str += str ? '&' : '?';
  //                     str += key + '=' + encodeURIComponent(obj[key]);
  //                 }
  //             }
  //             const url = `/tasktodo${str}`;
  //             const { data } = await axios.get(url);
  //             // resolve(data);
  //             const { meta, list } = data;
  //             obj.total = meta.total;
  //             resolve(list);
  //         } catch (error) {
  //             errorHandler(error, reject);
  //         }
  //     });
  // },
  listtodo(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/tasktodo`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
};
